import { authClient } from "@grafit/frontend-auth/auth-client";
import { createFileRoute } from "@tanstack/react-router";
import { redirect } from "../scaffolding/router-api";

export const Route = createFileRoute("/_no_auth")({
  beforeLoad: async () => {
    const { data: session } = await authClient.getSession();
    if (session?.user) {
      throw redirect({ to: "/", replace: true });
    }
  },
});
